import { Box, MenuList, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import ConfirmationDialog from '~/components/Dialogs/ConfirmationDialog';
import StructureSetItem from '~/components/Structures/StructureSetItem';
import { useAvailableStructureSetsView } from '~/hooks/domain/useAvailableStructureSetsView';
import useStructureSetSelection from '~/hooks/structure-set/useStructureSetSelection';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function StructureSetSelection() {
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const availableStructureSets = useAvailableStructureSetsView(true);
    const { handleStructureSetChange, imageChangeConfirmation } =
        useStructureSetSelection({});

    return (
        <Box display="grid">
            <Box px={1.5} pb={1}>
                <Typography fontSize={12} color="primary" fontWeight={500}>
                    <FormattedMessage id="selectStructureSet" />
                </Typography>
            </Box>
            <MenuList
                sx={{
                    py: 0,
                    '& .MuiMenuItem-root': {
                        px: 1.5,
                        borderRadius: 0,
                    },
                }}
            >
                {availableStructureSets.map((set) => {
                    const isActive =
                        currentStructureSet?.dicomUid === set.sopInstanceUid;

                    return (
                        <StructureSetItem
                            key={set.sopInstanceUid}
                            structureSet={set}
                            isActive={isActive}
                            onClick={() => handleStructureSetChange(set)}
                        />
                    );
                })}
            </MenuList>
            <ConfirmationDialog
                open={imageChangeConfirmation.open}
                title={<FormattedMessage id="confirmImageChange.title" />}
                message={<FormattedMessage id="confirmImageChange.message" />}
                onConfirm={imageChangeConfirmation.onConfirm}
                onCancel={imageChangeConfirmation.onCancel}
                mode="primary"
            />
        </Box>
    );
}
